import { useEffect, useState } from "react";
import CustomDatePicker from "../../atoms/CustomDatePicker";
import dayjs from "dayjs";

function MainDriver(props) {
  const otherDetails = props.otherDetails;
  const [btnPDValue, setPDBtnValue] = useState(
    otherDetails.driver.isPrimaryDriver
  );
  const handleClickDriver = (event) => {
    if (event.target.value === "N") {
      setPDBtnValue("N");
      props.setDriverDetails({
        ...props.driverDetails,
        ["driverName"]: "",
        ["birthday"]: "",
        ["birthday"]: "",
        ["isPrimaryDriver"]: event.target.value,
        ["driverGender"]: "",
        ["driverLicenseType"]: "",
      });
    } else {
      setPDBtnValue("Y");
      props.setDriverDetails({
        ...props.driverDetails,
        ["driverName"]: props.defaultData.name,
        ["birthday"]: props.defaultData.birthday,
        ["isPrimaryDriver"]: event.target.value,
        ["driverLicenseType"]: "",
        ["driverGender"]: "",
      });
    }
  };
  const handleUpdates = (e) => {
    props.setDriverDetails({
      ...props.driverDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleDateChange = (name, date) => {
    props.setDriverDetails({
      ...props.driverDetails,
      ["birthday"]: dayjs(date).format("YYYY-MM-DD"),
    });
  };
  const [loadingBdate, setLoadingBdate] = useState(false);
  useEffect(() => {
    setLoadingBdate(true);
  }, []);
  useEffect(() => {
    setLoadingBdate(true);
    setTimeout(() => {
      setLoadingBdate(false);
    }, 1000);
  }, [btnPDValue]);

  return (
    <>
      <div className="mt-10">
        <span className="block text-center font-semibold text-gray-500">
          Are you the primary driver of your car?
        </span>

        <span className="block font-semibold mt-1 text-gray-500">
          We’d love to know more about your car's primary driver. Don’t worry —
          this won’t prevent other authorized drivers from driving your car.
        </span>
        <div>
          <img
            alt="car-mortgagee"
            src={"/images/motor/motor-4.png"}
            className="mx-auto"
            width={300}
          />
        </div>
        <div className="flex">
          <div className="flex-1 text-center">
            <button
              type="button"
              className={
                btnPDValue === "Y"
                  ? "bg-blue-600 text-white py-3 w-11/12 rounded-full"
                  : "bg-white text-gray-500 py-3 w-11/12 rounded-full border border-gray-500"
              }
              onClick={handleClickDriver}
              value="Y"
            >
              YES
            </button>
          </div>
          <div className="flex-1 text-center">
            <button
              type="button"
              className={
                btnPDValue === "N"
                  ? "bg-blue-600 text-white py-3 w-11/12 rounded-full"
                  : "bg-white text-gray-500 py-3 w-11/12 rounded-full border border-gray-500"
              }
              onClick={handleClickDriver}
              value="N"
            >
              NO
            </button>
          </div>
        </div>
      </div>
      <div className="my-10">
        <span className="block font-semibold text-gray-500">
          Name of Primary driver
        </span>
        {!loadingBdate && (
          <input
            className="text-center input-form"
            name="driverName"
            onChange={handleUpdates}
            defaultValue={
              btnPDValue === "Y"
                ? props.defaultData.name
                : props.driverDetails.driverName
            }
            required
            placeholder="Driver Name"
            disabled={btnPDValue === "Y" ? true : false}
          />
        )}

        <span className="block font-semibold text-gray-500 mt-5">
          Birth Date of Primary Driver
        </span>
        {!loadingBdate && (
          <div className={"customDatepickerBorder mt-2"}>
            <CustomDatePicker
              name="birthdate"
              value={
                btnPDValue === "Y"
                  ? dayjs(new Date(props.defaultData.birthday))
                  : dayjs(new Date(props.driverDetails.birthday))
              }
              onChange={handleDateChange}
              disabled={btnPDValue === "Y" ? true : false}
            />
          </div>
        )}

        <span className="block font-semibold text-gray-500 mt-5">
          Gender of Primary Driver
        </span>
        {!loadingBdate && (
          <select
            name="driverGender"
            className="input-border-none focus:outline-none focus:shadow-outline"
            onChange={handleUpdates}
            defaultValue={props.driverDetails.driverGender}
            required
          >
            <option value="">Select gender</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
          </select>
        )}

        <span className="block font-semibold text-gray-500 mt-5">
          License Type of Primary Driver
        </span>
        {!loadingBdate && (
          <select
            name="driverLicenseType"
            className="input-border-none focus:outline-none focus:shadow-outline"
            onChange={handleUpdates}
            defaultValue={props.driverDetails.driverLicenseType}
            required
          >
            <option value="">Select driver type</option>
            <option value={"P"}>Professional</option>
            <option value={"N"}>Non-Professional</option>
          </select>
        )}
      </div>
    </>
  );
}

export default MainDriver;
